import { render, staticRenderFns } from "./suppliers.pug?vue&type=template&id=e64d565c&scoped=true&lang=pug&"
import script from "./suppliers.ts?vue&type=script&lang=ts&"
export * from "./suppliers.ts?vue&type=script&lang=ts&"
import style0 from "./suppliers.scss?vue&type=style&index=0&id=e64d565c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64d565c",
  null
  
)

export default component.exports